import { FC } from 'react';

import DefectHuidigeLocatie from '@/domain/defecten/components/DefectHuidigeLocatie';
import DefectTimeLabel from '@/domain/defecten/components/DefectTimeLabel';
import { defectIsBinnenPeriodeNietInzetbaar, defectTypeNietInzetbaar } from '@/domain/defecten/defect';
import { DefectGroupedByEenheid } from '@/domain/defecten/defectEenheid';
import DefectIcon from '@/views/ddp/components/defect/DefectIcon';

import { useSetSidepanelLmmMaterieel } from '../../state/selectors/useLmmSidepanelStore';

import styles from './LmmDefectListItem.module.css';

type LmmDefectListItemProps = {
  defect: DefectGroupedByEenheid;
  /** Toggle om het juiste label te tonen  */
  isVerwachtGereed?: boolean;
};

const LmmDefectListItem: FC<LmmDefectListItemProps> = ({ defect, isVerwachtGereed = false }) => {
  const setSidepanelLmmMaterieel = useSetSidepanelLmmMaterieel();
  const isAlNietInzetbaar = defectTypeNietInzetbaar(defect);
  const verwachtOfAlNietInzetbaar = isAlNietInzetbaar ? '' : 'Niet inzetbaar vanaf: ';
  return (
    <button
      data-testid={`materieelPanelToggle_${defect.eenheidNummer}`}
      type='button'
      className={`${styles.eenheidSidebarButton}`}
      onClick={() => setSidepanelLmmMaterieel(defect)}
    >
      <div className={styles.lmmDefect}>
        <div className={styles.lmmDefectHeader}>
          <div className={styles.eenheidNummer}>{defect.eenheidNummer}</div>
          {!isVerwachtGereed && (
            <DefectIcon
              defectSoort={isAlNietInzetbaar ? 'DEFECT_NIET_INZETBAAR' : defect.soort}
              nietInzetbaarBinnen24Uur={defectIsBinnenPeriodeNietInzetbaar(defect)}
            />
          )}
          <DefectHuidigeLocatie huidigeLocatie={defect?.huidigeLocatie} />
        </div>
        <DefectTimeLabel
          label={isVerwachtGereed ? 'Verwacht gereed: ' : verwachtOfAlNietInzetbaar}
          dateTime={isVerwachtGereed ? defect?.verwachtGereed : defect.nietMeerInzetbaarVanaf}
          variant={isAlNietInzetbaar && !isVerwachtGereed ? 'dayDateTime' : 'dayTime'}
        />
      </div>
    </button>
  );
};

export default LmmDefectListItem;
